import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./plantVerifyDetails.css";
import EditIcon from "@mui/icons-material/Edit";
import {
  authKey,
  FETCH_MATURED_DATE,
  GET_DROPDOWN_FOR_PLANTATION_BATCH,
  UPLOAD_DCUMENT,
  UPLOAD_PHOTO,
} from "../../..//common/URLs";

import "bootstrap/dist/css/bootstrap.min.css";
import { provideSeekClarificationPlantationBatch, viewdownloadDocument } from "../resourceCommonAPIs";
import { allowedFileTypes, FILE_NAME_VALIDATION_ERROR, PROD } from "../../..//common/constants";
import {
  Container,
  Stack,
  Box,
  Typography,
  Grid,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Paper,
  Divider,
  Chip,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import BackButton from "../../../common/backButton";
import { useTranslation } from "react-i18next";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { fileNameValidation, plantationValidation, resourceMaxLength, totalNumberOfClumpValidation } from "../../../common/commonValidations";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { toast } from "react-toastify";
import moment from "moment";
import { getWorkflowRequestDetails } from "../seeAllWorkList/workListAPIs";
import apiClient from "../../../axios";
import { DeleteIcon } from "../../../common/icons";
import { DataGrid } from "@mui/x-data-grid";

function PlantVerifyDetails() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [commentText, setCommentText] = useState(state?.speciesItem?.comment || "");
  const commentMaxLength = 500;

  const viewBatchDetails = state?.batchItem;
  const isEditable = state?.batchItem?.workflowRqstDtls?.previousStepAction === "Seek_Clarification";

  const [bambooSpecies, setBambooSpecies] = useState();
  const [saplingType, setSaplingType] = useState();
  const [saplingSource, setSaplingSource] = useState();
  const [showhidetype, setShowhidetype] = useState("");
  const [showhidesource, setShowhidesource] = useState("");
  const [selectedFile, setSelectedFile] = useState();
  const [documentUploadDetails, setDocumentUploadDetails] = useState();
  const [selectedPhotoFile, setSelectedPhotoFile] = useState();
  const [photoUploadDetails, setPhotoUploadDetails] = useState();
  const [openPhotoEdit, setOpenPhotoEdit] = useState(false);
  const [hidePhoto, setHidePhoto] = useState(true);
  const [openDocEdit, setOpenDocEdit] = useState(false);
  const [hideSponsorDoc, setHideSponsorDoc] = useState(true);
  const [provideClarificationResponse, setProvideClarificationResponse] = useState();
  const [workFlowRequestDetails, setWorkFlowRequestDetails] = useState();
  const [selectedPhotoFiles, setSelectedPhotoFiles] = useState([]);
  const [removedPlantationDocs, setRemovedPlantationDocs] = useState([]);
  const commentHistoryList = state?.speciesItem?.commentHistory || [];


  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);

  const [logConfirmModalOpen2, setLogConfirmModalOpen2] = useState(false);
  const handleConfirmLogModalOpen2 = () => setLogConfirmModalOpen2(true);
  const handleConfirmLogModalClose2 = () => setLogConfirmModalOpen2(false);

  const [logConfirmModalOpen3, setLogConfirmModalOpen3] = useState(false);
  const handleConfirmLogModalOpen3 = () => setLogConfirmModalOpen3(true);
  const handleConfirmLogModalClose3 = () => setLogConfirmModalOpen3(false);

  const [sponosoreDetails, setSponosoreDetails] = useState({
    id: viewBatchDetails?.id,
    requestNumber: viewBatchDetails?.requestNumber,
    sponsoredDocument: viewBatchDetails?.sponsoredDocument,
    sponsoredDocumentGuid: viewBatchDetails?.sponsoredDocumentGuid,
    documentContainerName: "resourcefiles"
  });

  const [viewSpeciesDetails, setViewSpeciesDetails] = useState({
    id: state?.speciesItem?.id,
    species: state?.speciesItem?.species,
    photoName: state?.speciesItem?.photoName,
    photoGuid: state?.speciesItem?.photoGuid,
    photoContainerName: "resourcefiles",
    saplingType: state?.speciesItem?.saplingType,
    saplingSource: state?.speciesItem?.saplingSource,
    saplingQuantity: state?.speciesItem?.saplingQuantity,
    noOfClumps: state?.speciesItem?.noOfClumps,
    dateOfPlantation: state?.speciesItem?.dateOfPlantation,
    maturedDate: state?.speciesItem?.maturedDate,
    isMatured: state?.batchItem?.isMatured, // add this
    speciesComment: state?.speciesItem?.speciesComment,
    avgBambooPolWgt: state?.speciesItem?.avgBambooPolWgt,
    avgBambooPolWgtUnit: state?.speciesItem?.avgBambooPolWgtUnit,
    latitude: state?.speciesItem?.latitude,
    longitude: state?.speciesItem?.longitude,
    plantationDocsAppList: state?.speciesItem?.plantationDocsAppList || [],
  });

  const [errorMessage, setErrorMessage] = useState({
    saplingTypeError: "",
    otherTypeOfSaplingError: "",
    saplingSourceError: "",
    otherSourceOfSaplingError: "",
    saplingQuantityError: "",
    dateOfPlantationError: "",
    noOfClumpsError: "",
    photoNameError: "",
    sponsoredDocumentError: "",
  });

  useEffect(() => {
    getDropdownValues();
  }, []);

  const getDropdownValues = () => {
    apiClient
      .post(
        GET_DROPDOWN_FOR_PLANTATION_BATCH,
        {
          urn: state?.batchItem?.urn,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setBambooSpecies(response.data.Bamboo_species);
        setSaplingType(response.data.Type_of_sapling);
        setSaplingSource(response.data.Source_of_sapling);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleDateChange = (value) => {
    setErrorMessage({ ...errorMessage, dateOfPlantationError: "" });
    setViewSpeciesDetails({
      ...viewSpeciesDetails,
      dateOfPlantation: value ? value.format("YYYY-MM-DD") : ""
    });
  };

  const onEditPhotoClick = () => {
    handleConfirmLogModalOpen();
  };

  function onCancelBack() {
    handleConfirmLogModalClose();
  }

  const onConfirmEdit = () => {
    handleConfirmLogModalClose();
    setOpenPhotoEdit(true);
    setHidePhoto(false);
  };

  const onEditDocClick = () => {
    handleConfirmLogModalOpen2();
  };

  function onCancelBack2() {
    handleConfirmLogModalClose2();
  }

  const onConfirmDocEdit = () => {
    handleConfirmLogModalClose2();
    setOpenDocEdit(true);
    setHideSponsorDoc(false);
  };

  const onSubmit = () => {
    handleConfirmLogModalOpen3();
  };

  function onCancelBack3() {
    handleConfirmLogModalClose3();
  }

  const onConfirmSubmit = () => {
    handleConfirmLogModalClose3();
    provideSeekClarificationPlantationBatch(sponosoreDetails, viewSpeciesDetails, setProvideClarificationResponse);
  };

  const handleChange = (e) => {
    setViewSpeciesDetails({ ...viewSpeciesDetails, [e.target.name]: e.target.value });

    if (e.target.name === "sameSpecies") {
      setErrorMessage({ ...errorMessage, sameSpeciesError: "" });
    }
    if (e.target.name === "species") {
      setErrorMessage({ ...errorMessage, speciesError: "", sameSpeciesError: "" });
    }
    if (e.target.name === "saplingType") {
      setErrorMessage({ ...errorMessage, saplingTypeError: "" });
      setShowhidetype(e.target.value);
    }
    if (e.target.name === "saplingSource") {
      setErrorMessage({ ...errorMessage, saplingSourceError: "" });
      setShowhidesource(e.target.value);
    }
    if (e.target.name === "saplingQuantity") {
      let slicedVal = plantationValidation(e.target.value);
      setViewSpeciesDetails({ ...viewSpeciesDetails, [e.target.name]: slicedVal });
      setErrorMessage({ ...errorMessage, saplingQuantityError: "" });
    }
    if (e.target.name === "averageClumpSize") {
      let slicedVal = plantationValidation(e.target.value);
      setViewSpeciesDetails({ ...viewSpeciesDetails, [e.target.name]: slicedVal });
    }
    if (e.target.name === "noOfClumps") {
      let slicedLandArea = totalNumberOfClumpValidation(e.target.value);
      setViewSpeciesDetails({ ...viewSpeciesDetails, [e.target.name]: slicedLandArea });
      if (slicedLandArea?.length === 0) {
        setErrorMessage({ ...errorMessage, noOfClumpsError: "Please enter Clump size" });
      } else {
        setErrorMessage({ ...errorMessage, noOfClumpsError: "", sameSpeciesError: "" });
      }
    }
    if (e.target.name === "avgBambooPolWgt") {
      let slicedVal = plantationValidation(e.target.value);
      setViewSpeciesDetails({ ...viewSpeciesDetails, [e.target.name]: slicedVal });
      setErrorMessage({ ...errorMessage, avgBambooPolWgtError: "" });
    }
  };

  useEffect(() => {
    if (selectedPhotoFile) {
      getUploadPhotoDetails();
    }
  }, [selectedPhotoFile]);

  function getUploadPhotoDetails() {
    loaderService.showLoader();
    const formData = new FormData();
    formData.append("file", selectedPhotoFile);
    formData.append("fileName", selectedPhotoFile.name);
    formData.append("containerName", "resourcefiles");
    apiClient
      .post(UPLOAD_PHOTO, formData, {
        headers: {
          AuthKey: authKey,
        },
      })
      .then((response) => {
        setPhotoUploadDetails(response.data);
        setViewSpeciesDetails((prev) => ({
          ...prev,
          plantationDocsAppList: [
            ...(prev.plantationDocsAppList || []),
            {
              documentName: response.data.blobResponse.fileName,
              documentGuid: response.data.blobResponse.blobFileName,
              containerName: "resourcefiles",
              isActive: "Y",
            },
          ],
          photoGuid: response.data.blobResponse.blobFileName,
          photoName: response.data.blobResponse.fileName,
        }));
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  useEffect(() => {
    if (selectedFile) {
      getUploadDocumentDetails();
    }
  }, [selectedFile]);

  const uploadDocument = (e) => {
    if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
      return;
    }
    if (e.target.files[0].size >= 5000000) {
      setErrorMessage({
        ...errorMessage,
        sponsoredDocumentError: "The file should be less than 5MB",
      });
    } else if (e.target.files[0].name.split(".")?.length > 2) {
      setErrorMessage({
        ...errorMessage,
        sponsoredDocumentError: "Double extension file detected",
      });
      setSelectedFile();
    } else if (fileNameValidation(e.target.files[0].name)) {
      setErrorMessage({
        ...errorMessage,
        sponsoredDocumentError: FILE_NAME_VALIDATION_ERROR,
      });
      setSelectedFile();
    } else {
      setSelectedFile(e.target.files[0]);
      setErrorMessage({ ...errorMessage, sponsoredDocumentError: " " });
    }
  };

  function getUploadDocumentDetails() {
    loaderService.showLoader();
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("fileName", selectedFile.name);
    formData.append("containerName", "resourcefiles");
    apiClient
      .post(UPLOAD_DCUMENT, formData, {
        headers: {
          AuthKey: authKey,
        },
      })
      .then((response) => {
        setDocumentUploadDetails(response.data);
        setSponosoreDetails({
          ...sponosoreDetails,
          sponsoredDocumentGuid: response.data.blobResponse.blobFileName,
          sponsoredDocument: response.data.blobResponse.fileName
        });
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  useEffect(() => {
    if (viewSpeciesDetails?.dateOfPlantation) {
      getMaturedDate();
    }
  }, [viewSpeciesDetails?.dateOfPlantation]);

  const getMaturedDate = () => {
    loaderService.showLoader();
    apiClient
      .post(
        FETCH_MATURED_DATE,
        {
          plantationDate: viewSpeciesDetails?.dateOfPlantation,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        loaderService.hideLoader();
        setViewSpeciesDetails({
          ...viewSpeciesDetails,
          maturedDate: response.data.plantationMaturedDate
        });
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  useEffect(() => {
    if (provideClarificationResponse) {
      if (provideClarificationResponse?.status === "SUCCESS") {
        toast.success(provideClarificationResponse?.description);
        getWorkflowRequestDetails(
          sponosoreDetails?.requestNumber,
          setWorkFlowRequestDetails,
          state?.type === "sent" ? "Y" : "N"
        );
      } else {
        toast.error(provideClarificationResponse?.description);
      }
    }
  }, [provideClarificationResponse]);

  useEffect(() => {
    if (workFlowRequestDetails) {
      navigate("/resourcedashboard/home/allWorkList/plantViewDetails", {
        state: {
          workFlowRequestDetails: workFlowRequestDetails,
          selectedRequestNumber: sponosoreDetails?.requestNumber,
          type: state?.type
        }
      });
    }
  }, [workFlowRequestDetails]);

  const uploadPhoto = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    let validationError = "";

    for (const file of files) {
      if (allowedFileTypes.indexOf(file.type) < 0) {
        validationError = "Invalid file type";
        break;
      }
      if (file.size >= 5000000) {
        validationError = "Each file should be less than 5MB";
        break;
      }
      if (file.name.split(".")?.length > 2) {
        validationError = "Double extension file detected";
        break;
      }
      if (fileNameValidation(file.name)) {
        validationError = FILE_NAME_VALIDATION_ERROR;
        break;
      }
    }

    if (validationError) {
      setErrorMessage((prev) => ({
        ...prev,
        photoNameError: validationError,
      }));
      return;
    }

    setErrorMessage((prev) => ({
      ...prev,
      photoNameError: "",
    }));

    await uploadMultiplePhotos(files);
  };

  const uploadMultiplePhotos = async (files) => {
    loaderService.showLoader();

    try {
      const uploadedDocs = [];

      for (const file of files) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", file.name);
        formData.append("containerName", "resourcefiles");

        const response = await apiClient.post(UPLOAD_PHOTO, formData, {
          headers: {
            AuthKey: authKey,
          },
        });

        uploadedDocs.push({
          id: null,
          containerName: "resourcefiles",
          documentName: response.data?.blobResponse?.fileName,
          documentGuid: response.data?.blobResponse?.blobFileName,
          landName: state?.batchItem?.landName || state?.batchItem?.landDetails?.landName || "",
          landId: state?.batchItem?.landId,
          plantBatchNo: state?.batchItem?.plantationBatchNo,
          speciesDocId: viewSpeciesDetails?.speciesDocId,
          isActive: "Y",
        });
      }

      setViewSpeciesDetails((prev) => ({
        ...prev,
        plantationDocsAppList: [
          ...(prev.plantationDocsAppList || []),
          ...uploadedDocs,
        ],
      }));
    } catch (error) {
      console.log(error);
    } finally {
      loaderService.hideLoader();
    }
  };

  const handleRemoveDoc = (doc) => {
    setViewSpeciesDetails((prev) => ({
      ...prev,
      plantationDocsAppList: prev.plantationDocsAppList.filter(
        (d) => d.documentGuid !== doc.documentGuid
      ),
    }));

    setRemovedPlantationDocs((prev) => [
      ...prev,
      { ...doc, isActive: "N" },
    ]);
  };

  const cardSx = {
    backgroundColor: "#fff",
    borderRadius: 2,
    boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
    border: "1px solid #e5e7eb",
    p: { xs: 2, sm: 2.5, md: 3 },
    mb: 2
  };

  const sectionTitleSx = {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#1f2937",
    mb: 2
  };

  const commentHistoryRows = (commentHistoryList || []).map((item, index) => ({
    id: item?.id || index,
    comment: item?.comment || "-",
    commentDate: item?.commentDate
      ? moment(item.commentDate).format("DD/MM/YYYY")
      : "-",
    commentedBy:
      item?.commentedBy ||
      item?.commentedByName ||
      item?.createdByName ||
      item?.createdBy ||
      "-",
  }));

  const commentHistoryColumns = [
    {
      field: "comment",
      headerName: "Comment",
      flex: 1.8,
      minWidth: 260,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            py: 1,
            lineHeight: 1.4
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: "commentDate",
      headerName: "Comment Date",
      flex: 1,
      minWidth: 180,
    },
    {
      field: "commentedBy",
      headerName: "Commented By",
      flex: 1,
      minWidth: 180,
    },
  ];

  const handleCommentChange = (e) => {
    const value = e.target.value.slice(0, commentMaxLength);
    setCommentText(value);
    setViewSpeciesDetails((prev) => ({
      ...prev,
      comment: value,
    }));
  };

  return (
    <Box sx={{ minHeight: "100vh", py: 3 }}>
      <Container maxWidth="xl">
        {!PROD && (
          <Typography
            className="pageNumberingResc"
            sx={{
              textAlign: "center",
              fontSize: "12px",
              color: "text.secondary",
              mb: 1
            }}
          >
            RES26
          </Typography>
        )}

        {/* Header */}
        <Paper
          elevation={0}
          sx={{
            p: 2.5,
            mb: 3,
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            backgroundColor: "#ffffff"
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
            spacing={2}
          >
            <Stack direction="row" spacing={1.5} alignItems="center">
              <BackButton navigate={navigate} />
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  Plantation Verification Details
                </Typography>
                {/* <Typography variant="body2" color="text.secondary">
                  Review plantation species information and supporting documents
                </Typography> */}
              </Box>
            </Stack>

            <Stack direction="row" spacing={1} flexWrap="wrap">
              <Chip
                label={`Batch No: ${state?.batchItem?.plantationBatchNo || "-"}`}
                variant="outlined"
              />
              <Chip
                label={isEditable ? "Editable" : "View Only"}
                color={isEditable ? "warning" : "default"}
                variant="outlined"
              />
            </Stack>
          </Stack>
        </Paper>

        {/* Sponsored Details */}
        {state?.batchItem?.isSponsored === "yes" && (
          <Paper
            elevation={0}
            sx={{
              p: 3,
              mb: 3,
              borderRadius: 2,
              border: "1px solid #e0e0e0",
              backgroundColor: "#ffffff"
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Sponsorship Details
            </Typography>
            <Divider sx={{ mb: 2.5 }} />

            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl fullWidth>
                  <TextField
                    label="Sponsored Type"
                    type="text"
                    value={state?.batchItem?.sponsoredType || ""}
                    disabled
                  />
                  <FormHelperText sx={{ color: "red" }}> </FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Sponsored Remarks"
                    name="sponsoredRemarks"
                    value={state?.batchItem?.sponsoredRemarks || ""}
                    disabled
                  />
                  <FormHelperText sx={{ color: "red" }}> </FormHelperText>
                </FormControl>
              </Grid>

              {hideSponsorDoc && (
                <Grid item xs={12} md={12} lg={3}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Uploaded Sponsorship Document
                  </Typography>
                  <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                    <Typography
                      sx={{ cursor: "pointer", color: "#1976d2", wordBreak: "break-word" }}
                      onClick={() =>
                        viewdownloadDocument(
                          viewBatchDetails?.sponsoredDocumentGuid,
                          "resourcefiles",
                          viewBatchDetails?.sponsoredDocument
                        )
                      }
                    >
                      {viewBatchDetails?.sponsoredDocument}
                    </Typography>
                    <EditIcon
                      sx={{ cursor: "pointer" }}
                      onClick={(e) => onEditDocClick(e)}
                      hidden={!isEditable}
                    />
                  </Box>
                </Grid>
              )}

              {openDocEdit && (
                <Grid item xs={12}>
                  <Typography sx={{ mb: 1 }}>
                    {t("resource.uploadDocument")} <span className="mandatory_field">*</span>
                  </Typography>
                  <div className="geocode-photo-choosefile">
                    <label className="chooseFile-create-plantation">
                      <input
                        style={{ display: "none" }}
                        type="file"
                        accept="image/jpeg, image/png, .txt, .doc, .pdf, .csv, .ppt, .mp4"
                        name="sponsoredDocument"
                        onChange={(e) => uploadDocument(e)}
                      />
                      {t("resource.chooseFile")}
                    </label>
                    <label className="photoName-create-plantation">
                      {sponosoreDetails?.sponsoredDocument}
                    </label>
                    <div className="resource-common-error-message">
                      {errorMessage.sponsoredDocumentError}
                    </div>
                  </div>
                  <span className="file_info">{t("preReg.uploadFileTypeNote")}</span>
                </Grid>
              )}
            </Grid>
          </Paper>
        )}

        {/* Plantation Info */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            backgroundColor: "#ffffff"
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
            Plantation Details
          </Typography>
          <Divider sx={{ mb: 2.5 }} />

          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <InputLabel>{t("reg.bambooSpecies")}</InputLabel>
                <Select
                  label={t("reg.bambooSpecies")}
                  name="species"
                  onChange={(e) => handleChange(e)}
                  value={viewSpeciesDetails?.species || ""}
                  disabled={!isEditable}
                >
                  <MenuItem>
                    <em>{t("reg.bambooSpecies")}</em>
                  </MenuItem>
                  {bambooSpecies &&
                    bambooSpecies.map((item, index) => (
                      <MenuItem key={index} value={item.value}>
                        {item.value}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText sx={{ color: "red" }}> </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label={t("resource.dateOfNewPlantation")}
                    inputFormat="DD/MM/YYYY"
                    name="dateOfPlantation"
                    disabled={!isEditable}
                    value={viewSpeciesDetails?.dateOfPlantation || null}
                    onChange={(value) => handleDateChange(value)}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />
                </LocalizationProvider>
                <FormHelperText sx={{ color: "red" }}>{errorMessage.dateOfPlantationError}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <TextField
                  label={t("resource.plantationMaturedDate")}
                  disabled
                  value={
                    viewSpeciesDetails?.maturedDate
                      ? moment(viewSpeciesDetails?.maturedDate).format("DD/MM/YYYY")
                      : ""
                  }
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <TextField
                  label={t("resource.saplingQuantity")}
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  name="saplingQuantity"
                  onChange={(e) => handleChange(e)}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "E" || evt.key === "-" || evt.key === "+") &&
                    evt.preventDefault()
                  }
                  value={viewSpeciesDetails?.saplingQuantity || ""}
                  disabled={!isEditable}
                />
                <FormHelperText sx={{ color: "red" }}>{errorMessage.saplingQuantityError}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <InputLabel>{t("resource.saplingType")}</InputLabel>
                <Select
                  label={t("resource.saplingType")}
                  name="saplingType"
                  disabled={!isEditable}
                  value={
                    (saplingType &&
                      saplingType.find((item) => item.value === viewSpeciesDetails.saplingType)) ||
                      !viewSpeciesDetails?.saplingType
                      ? viewSpeciesDetails?.saplingType || ""
                      : "Others" || ""
                  }
                  onChange={(e) => handleChange(e)}
                >
                  <MenuItem disabled>
                    <em>{t("resource.saplingType")}</em>
                  </MenuItem>
                  {saplingType &&
                    saplingType.map((item, index) => (
                      <MenuItem key={index} value={item.value}>
                        {item.value}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText sx={{ color: "red" }}>{errorMessage.saplingTypeError}</FormHelperText>
              </FormControl>
            </Grid>

            {viewSpeciesDetails?.saplingType === "Others" && (
              <Grid item xs={12} md={6} lg={3}>
                <FormControl fullWidth>
                  <TextField
                    label={t("resource.otherSaplingType")}
                    name="saplingType"
                    inputProps={{
                      maxLength: resourceMaxLength
                    }}
                    disabled={!isEditable}
                    value={viewSpeciesDetails?.saplingType || ""}
                    onChange={(e) => handleChange(e)}
                  />
                  <FormHelperText sx={{ color: "red" }}></FormHelperText>
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <InputLabel>{t("resource.saplingSource")}</InputLabel>
                <Select
                  label={t("resource.saplingSource")}
                  name="saplingSource"
                  disabled={!isEditable}
                  value={
                    (saplingSource &&
                      saplingSource.find((item) => item.value === viewSpeciesDetails.saplingSource)) ||
                      !viewSpeciesDetails?.saplingSource
                      ? viewSpeciesDetails?.saplingSource || ""
                      : "Others" || ""
                  }
                  onChange={(e) => handleChange(e)}
                >
                  <MenuItem disabled>
                    <em>{t("resource.saplingSource")}</em>
                  </MenuItem>
                  {saplingSource &&
                    saplingSource.map((item, index) => (
                      <MenuItem key={index} value={item.value}>
                        {item.value}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText sx={{ color: "red" }}>{errorMessage.saplingSourceError}</FormHelperText>
              </FormControl>
            </Grid>

            {viewSpeciesDetails?.saplingSource === "Other" && (
              <Grid item xs={12} md={6} lg={3}>
                <FormControl fullWidth>
                  <TextField
                    label={t("resource.otherSaplingSource")}
                    name="saplingSource"
                    inputProps={{
                      maxLength: resourceMaxLength
                    }}
                    disabled={!isEditable}
                    value={viewSpeciesDetails?.saplingSource || ""}
                    onChange={(e) => handleChange(e)}
                  />
                  <FormHelperText sx={{ color: "red" }}></FormHelperText>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <TextField
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  label="Latitude"
                  name="latitude"
                  value={state?.speciesItem?.latitude || ""}
                  disabled
                />
                <FormHelperText sx={{ color: "red" }}> </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <TextField
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  label="Longitude"
                  name="longitude"
                  value={state?.speciesItem?.longitude || ""}
                  disabled
                />
                <FormHelperText sx={{ color: "red" }}> </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <TextField
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  label={t("reg.noOfClumps")}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "E" || evt.key === "-" || evt.key === "+") &&
                    evt.preventDefault()
                  }
                  name="noOfClumps"
                  onChange={(e) => handleChange(e)}
                  value={viewSpeciesDetails?.noOfClumps || ""}
                  disabled={!isEditable}
                />
                <FormHelperText sx={{ color: "red" }}>{errorMessage.noOfClumpsError}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <TextField
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  label="Average clump size"
                  name="averageClumpSize"
                  value={state?.speciesItem?.averageClumpSize || ""}
                  disabled
                />
                <FormHelperText sx={{ color: "red" }}> </FormHelperText>
              </FormControl>
            </Grid>



            <Grid item xs={12} md={6} lg={3}>
              <FormControl fullWidth>
                <TextField
                  label={t("resource.averageBambooPoleWeightinKg")}
                  name="avgBambooPolWgt"
                  disabled
                  value={state?.speciesItem?.avgBambooPolWgt || ""}
                />
                <FormHelperText sx={{ color: "red" }}> </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={3}></Grid>
            <Grid item xs={12} md={6} lg={3}>
              <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend">Is Matured</FormLabel>
                <RadioGroup
                  row
                  name="isMatured"
                  value={
                    viewSpeciesDetails?.isMatured === true || viewSpeciesDetails?.isMatured === "Y"
                      ? "Y"
                      : viewSpeciesDetails?.isMatured === false || viewSpeciesDetails?.isMatured === "N"
                        ? "N"
                        : ""
                  }
                  onChange={(e) =>
                    setViewSpeciesDetails((prev) => ({
                      ...prev,
                      isMatured: e.target.value,
                    }))
                  }
                >
                  <FormControlLabel value="Y" control={<Radio />} label="Yes" disabled={!isEditable} />
                  <FormControlLabel value="N" control={<Radio />} label="No" disabled={!isEditable} />
                </RadioGroup>
              </FormControl>
            </Grid>
            {isEditable && (
              <Grid item xs={12} lg={9}>
                <TextField
                  fullWidth
                  multiline
                  minRows={4}
                  maxRows={6}
                  label="Comment"
                  value={commentText}
                  onChange={handleCommentChange}
                  inputProps={{ maxLength: commentMaxLength }}
                />

                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                  <Typography variant="caption" sx={{ color: "#6b7280" }}>
                    {commentText?.length || 0}/{commentMaxLength}
                  </Typography>
                </Box>
              </Grid>
            )}

            {hidePhoto && (
              <Grid item xs={12} lg={6}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Uploaded Photos / Documents
                </Typography>

                {(viewSpeciesDetails?.plantationDocsAppList || []).length > 0 ? (
                  (viewSpeciesDetails?.plantationDocsAppList || []).map((doc, i) => (
                    <Box
                      key={doc?.documentGuid || i}
                      display="flex"
                      alignItems="center"
                      gap={1}
                      mb={1}
                      flexWrap="wrap"
                    >
                      <Typography
                        sx={{ cursor: "pointer", color: "#1976d2", wordBreak: "break-word" }}
                        onClick={() =>
                          viewdownloadDocument(
                            doc?.documentGuid,
                            doc?.containerName || "resourcefiles",
                            doc?.documentName
                          )
                        }
                      >
                        {doc?.documentName}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                    <Typography
                      sx={{ cursor: "pointer", color: "#1976d2", wordBreak: "break-word" }}
                      onClick={() =>
                        viewdownloadDocument(
                          viewSpeciesDetails?.photoGuid,
                          "resourcefiles",
                          viewSpeciesDetails?.photoName
                        )
                      }
                    >
                      {viewSpeciesDetails?.photoName}
                    </Typography>
                  </Box>
                )}

                <Button variant="outlined" hidden={!isEditable} onClick={(e) => onEditPhotoClick(e)} startIcon={<EditIcon/>}>Edit</Button>
              </Grid>
            )}

            {openPhotoEdit && (
              <Grid item xs={12}>
                <Typography sx={{ mb: 1 }}>
                  {t("resource.uploadPhotos")}
                  <span className="mandatory_field">*</span>
                </Typography>

                {(viewSpeciesDetails?.plantationDocsAppList || []).length > 0 && (
                  <Box sx={{ mb: 2 }}>
                    {(viewSpeciesDetails?.plantationDocsAppList || []).map((doc, i) => (
                      <Box
                        key={doc?.documentGuid || i}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1,
                          flexWrap: "wrap"
                        }}
                      >
                        <Typography
                          sx={{ cursor: "pointer", color: "#1976d2", wordBreak: "break-word" }}
                          onClick={() =>
                            viewdownloadDocument(
                              doc?.documentGuid,
                              doc?.containerName || "resourcefiles",
                              doc?.documentName
                            )
                          }
                        >
                          {doc?.documentName}
                        </Typography>

                        <Button
                          size="small"
                          color="error"
                          onClick={() => handleRemoveDoc(doc)}
                          sx={{ minWidth: "auto", padding: "2px 6px" }}
                        >
                          <DeleteIcon fontSize="small" />
                        </Button>
                      </Box>
                    ))}
                  </Box>
                )}

                <div className="geocode-photo-choosefile">
                  <label className="chooseFile-create-plantation">
                    <input
                      style={{ display: "none" }}
                      type="file"
                      accept="image/jpeg, image/jpg, image/png, .pdf"
                      name="photo"
                      multiple
                      onChange={(e) => uploadPhoto(e)}
                    />
                    {t("resource.chooseFile")}
                  </label>

                  <label className="photoName-create-plantation">
                    {viewSpeciesDetails?.photoName}
                  </label>

                  <div className="resource-common-error-message">
                    {errorMessage.photoNameError}
                  </div>
                </div>

                <span className="file_info">{t("preReg.uploadFileTypeNote")}</span>
              </Grid>
            )}

            {commentHistoryList?.length > 0 && (
              <Grid item xs={12} lg={12}>
                <Stack spacing={1.5}>
                  {commentHistoryList?.length > 0 && (
                    <Grid item xs={12} lg={12}>
                      <Box sx={cardSx}>
                        <Typography sx={sectionTitleSx}>Comment History</Typography>

                        <Box sx={{ width: "100%" }}>
                          <DataGrid
                            autoHeight
                            rows={commentHistoryRows}
                            columns={commentHistoryColumns}
                            disableRowSelectionOnClick
                            hideFooter
                            getRowHeight={() => "auto"}
                            sx={{
                              "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#f3f4f6",
                                fontWeight: 600,
                              },
                              "& .MuiDataGrid-cell": {
                                alignItems: "center",
                                py: 1,
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  )}
                </Stack>
              </Grid>
            )}
          </Grid>
        </Paper>

        {isEditable && (
          <Box display="flex" justifyContent="flex-end">
            <Button sx={{ minWidth: 120 }} variant="contained" onClick={(e) => onSubmit(e)}>
              Save
            </Button>
          </Box>
        )}
      </Container>

      <ConfirmationPopover
        onOpen={logConfirmModalOpen}
        onConfirm={onConfirmEdit}
        onClose={onCancelBack}
        action="Edit Plantation Document"
      />
      <ConfirmationPopover
        onOpen={logConfirmModalOpen2}
        onConfirm={onConfirmDocEdit}
        onClose={onCancelBack2}
        action="Edit Sponsorship Document"
      />
      <ConfirmationPopover
        onOpen={logConfirmModalOpen3}
        onConfirm={onConfirmSubmit}
        onClose={onCancelBack3}
        action="Submit"
      />
    </Box>
  );
}

export default PlantVerifyDetails;